import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonGroup,
  Button,
} from 'react-bootstrap';
import { browserHistory } from 'react-router';
import { displayBidderBidState } from '../../../core/api';
import BidDetailPanel from './BidDetailPanel';
import AddNoteModel from './AddNoteModel';
import StyledGriddle from '../../../components/StyledGriddle';
import { fullDate, monthNameFormatDate } from '../../../core/date';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton } from 'react-bootstrap-table';


const sortProperties = [
  { id: 'start', sortAscending: true },
  { id: 'group', sortAscending: true },
  { id: 'name', sortAscending: true },
];

const getStatusData =(row,cell) => {
  let value = cell.proStatus;
  if(value ===' '){
    return(
      <span><b> </b></span>
    )    
  } else{
    return(
      <span title="New Bid"><b style={{color:'green'}}><i className="fa fa-solid fa-circle fa-lg" /></b></span>
    )
  }
};

const dateDisplayStart = ( row,cell ) => {
  let start = cell.start;
  if(cell.start){
    let start = cell.start;
  } else{
    let start = row;
  }
  let startValue = monthNameFormatDate(start);
  return(
    <span>{startValue}</span>
    );
};
const dateDisplayEnd = ( row,cell ) => {
  let end = cell.end;
  if(cell.end){
    let end = cell.end;
  } else{
    let end = row;
  }
  let endValue = monthNameFormatDate(end);
  return(
    <span>{endValue}</span>
    )
};

function findById(value) {
  console.log('findById ', value.id, this);
  return value.id === Number(this);
}
function getUserDisplay(user) {
  if (user) {
    if (user.first_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    return user.username;
  }
  return 'Unassigned';
}

class ProposalTable extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      show:false,
      BidId:null,
      noteData:this.props.proposal.proposalInfos,
    };
    if (props.detail) {
      this.state = {
        bid: props.detail,
      };
    }
    this.showBid = this.showBid.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.addNote = this.addNote.bind(this);
    this.closeNote = this.closeNote.bind(this);
    this.submitNoteData = this.submitNoteData.bind(this);
    this.copyUrl = this.copyUrl.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.detail !== nextProps.detail) {
      if (nextProps.detail) {
        this.setState({
          bid: nextProps.detail,
        });
      } else {
        this.setState({
          bid: nextProps.detail,
        });
      }
    }
  }
  closeModal() {
    const url = `/booking/${this.props.proposal.id}`;
    browserHistory.push(url);
  }
  showBid(e) {
    e.preventDefault();
    const bid = e.currentTarget.getAttribute('data-item');
    if (bid) {
      const url = `/booking/${this.props.proposal.id}/${bid}`;
      browserHistory.push(url);
      let payload = {'proposalId':this.props.proposal.id,'bidId':bid,'status':'old'}
      this.props.changeBrandStatus(this.props.proposal.id,payload,(response) =>{
        console.log("response")
      });
    }
  }
  copyUrl(e){
    const bidId = e.currentTarget.getAttribute('data-item');
    let bid = this.findBid(bidId);
    let url = bid.bid_url;
    navigator.clipboard.writeText(url);
  }
  findBid(id) {
    const idx = this.props.proposal.bids.findIndex(findById, id);
    if (idx === -1) {
      console.log('Unable to find bid: ', id);
      return {};
    }
    return this.props.proposal.bids[idx];
  }

  closeNote(){
    this.setState({show:false});
  }

  addNote(e){
    const bidId = e.currentTarget.getAttribute('data-item');
    this.setState({
      show:true,
      BidId:bidId,
    });
  }
  submitNoteData(id,note){
    this.props.addNotesBrand(id,note,(response) =>{
      this.setState({
        noteData:response
      })
    });

  }
  ButtonColumn = (row,rowIndex) => {
  return(
      <div>
        <ButtonGroup>
          <Button bsStyle="info" title="View Bid" data-item={row} onClick={this.showBid}>
            <i className="fa fa-pencil fa-lg" />
          </Button>
        </ButtonGroup>&nbsp;&nbsp;

        <ButtonGroup>
          <Button bsStyle="info" title="Copy Bid URL" data-item={row} onClick={this.copyUrl}>
            <i className="fa fa-link fa-lg" />
          </Button>
        </ButtonGroup>&nbsp;&nbsp;

        <ButtonGroup>
          <Button bsStyle="info" title="Add Bid Note" data-item={row} onClick={this.addNote}>
            <i className="fa fa-book fa-lg" />
          </Button>
        </ButtonGroup>
      </div>
    )
};

  render() {
    const proposalId = this.props.proposal.id;

    const proposalInfos = [];
    const convertedBids = [];
    const info = this.props.proposal.proposalInfos;
    const bids = this.props.proposal.bids;

    if (info){
      info.forEach((val) =>{
        proposalInfos.push({
          bid: val.bid,
          status: val.status,
        });
      });
    }

    if (bids) {
      bids.forEach((bid) => {
        let start
        let end
        if(bid.bidset){
          console.log("bid.........................",bid)
          this.props.proposal.tour.tour_stops.filter(item => {
            if (item.place.name === bid.bidset.event.place.name) {
              
              return item.related_group_events.filter(itme2=>{
                if(itme2.group === bid.tourgroup_id && itme2.parent === bid.bidset.event.parent){
                  start = itme2.bids.bid_details.length>0?itme2.bids.bid_details[0].lowest_check_in_date:itme2.start
                  end = itme2.bids.bid_details.length>0?itme2.bids.bid_details[0].greatest_check_out_date:itme2.end
                }
              })
            }
            else{
              return null
            }
          });
        }
      

        const displayState = displayBidderBidState(bid.buyer_state, bid.bidder_state);
        if (!['Unsent'].includes(displayState) && bid.bidset) {
          convertedBids.push({
            id: bid.id,
            name: bid.hotel.name,
            group: bid.bidset.event.group_name,
            location: `${bid.hotel.locality}, ${bid.hotel.region}`,
            start:start?start:bid.bidset.event.start,
            end:end?end:bid.bidset.event.end,
            bidder: getUserDisplay(bid.bidder),
            state: displayState,
            proStatus: ' ',
          });
        }
      });
    }

    if(proposalInfos !=null && convertedBids !=null){
      convertedBids.forEach((bid) => {
        proposalInfos.forEach((info) => {
          if(bid.id==info.bid){
            if (info.status=='new'){
              bid.proStatus = info.status
            }
            if(bid.state=='Viewed'){
              bid.proStatus = ' '
            }
          }
        });
      });
    }

    return (
      <div>
        {this.state.show && (
          <AddNoteModel
            BidId={this.state.BidId}
            proposalId={proposalId}
            show={this.state.show}
            onClose={this.closeNote}
            submitNoteData={this.submitNoteData}
          />
          )}
        {this.props.detail && (
          <BidDetailPanel
            profilename={this.props.profilename}
            bid={this.findBid(this.state.bid)}
            show={this.props.detail}
            onClose={this.closeModal}
            editBid={this.props.editBid}
            addBidNote={this.props.addBidNote}
            sendBid={this.props.sendBid}
            user={this.props.user}
            addAnswers={this.props.addAnswers}
            requestAnswers={this.props.requestAnswers}
            addedanswers={this.props.answers}
            proposalId={proposalId}
            getNotesBrand={this.props.getNotesBrand}
            updateHotelContacts={this.props.updateHotelContacts}
            deleteHotelContacts={this.props.deleteHotelContacts}
            {...this.props}
          />
        )}
        {!this.props.detail && (
        <BootstrapTable data={convertedBids }>
          <TableHeaderColumn dataField='proStatus' width='35' dataSort={ true } dataAlign="center" headerAlign="center" dataFormat={getStatusData} > </TableHeaderColumn>
          <TableHeaderColumn dataField='name' width='130' dataAlign="center" headerAlign="center">name</TableHeaderColumn>
          <TableHeaderColumn dataField='group' width='100' dataAlign="center" headerAlign="center">group</TableHeaderColumn>
          <TableHeaderColumn dataField='location' width='100' dataAlign="center" headerAlign="center">location</TableHeaderColumn>
          <TableHeaderColumn dataField='start' width='100' dataAlign="center" headerAlign="center" dataFormat={dateDisplayStart}>Check In</TableHeaderColumn>
          <TableHeaderColumn dataField='end' width='100' dataAlign="center" headerAlign="center" dataFormat={dateDisplayEnd}>Check Out</TableHeaderColumn>
          <TableHeaderColumn dataField='state' width='80' dataAlign="center" headerAlign="center">Status</TableHeaderColumn>
          <TableHeaderColumn dataField='bidder' width='94' dataAlign="center" headerAlign="center">Contact</TableHeaderColumn>
          <TableHeaderColumn dataField='id' width='160' isKey={true} dataAlign="center" headerAlign="center" dataFormat={this.ButtonColumn} > </TableHeaderColumn>
        </BootstrapTable>
        )}
      </div>
    );
  }
}


ProposalTable.propTypes = {
  proposal: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  detail: PropTypes.string,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
};

ProposalTable.defaultProps = {
  proposal: {
    bids: [],
  },
  detail: null,
};
export default ProposalTable;


// WEBPACK FOOTER //
// src/routes/booking/components/ProposalTable.js